
<script>
import PieChart from "./pieChart.vue";


export default {

  components: { PieChart},

  data(){
        return{
            selectedIdentifier: null,
            customDropDownRateByIdentifier: null,
            customDropDownRateKey: 0,
            isMobile: window.innerWidth <= 480,

        }
    },

  props: {

    customDropDownRate: {
        type: Array,
        default: () => null
        }
    },

    computed:{

        customDropDownIdentifier() {
        if(!this.customDropDownRate){
            return null
        }

        const identifierList = this.customDropDownRate
            .filter(cddr => cddr.identifier != null)
            .map(cddr => cddr.identifier);

        return identifierList
        },
    },

    mounted(){
        this.selectedIdentifier = this.customDropDownIdentifier[0]

    },

    watch:{
        selectedIdentifier:function(){
            if (!this.selectedIdentifier){
                this.selectedIdentifier = this.customDropDownIdentifier[0]
            }

            this.customDropDownRateByIdentifier = this.customDropDownRate.filter(cddr => cddr.identifier ==  this.selectedIdentifier)[0]
            this.customDropDownRateKey ++
        }
    }

 
};
</script>

<template>

    <div class="card h-100"  style="border:1px solid #ddd;">
        <div class="card-body h-100"> 

            <h4 class="text-dark text-uppercase font-weight-bold">{{$t('campaign.card.customDropDownRate') }}</h4>
            <div  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group  label-for="">
                <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customDropDownIdentifier" :placeholder="$t('lists.identifier.label')" v-model="selectedIdentifier">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div>


         <PieChart  v-if="customDropDownRateByIdentifier && customDropDownRateByIdentifier.count && customDropDownRateByIdentifier.labels " 
                    :data="customDropDownRateByIdentifier.count" 
                    :labels="customDropDownRateByIdentifier.labels" 
                    :key="customDropDownRateKey"
                    :hideLeagend="isMobile"
                    />
        </div> 
    </div>

</template>

<style>

 .apexcharts-theme-light{
    width: auto !important;
    text-align: center !important;
}

</style>